import { authHeader } from '../helpers';
import FileSaver from 'file-saver';
import {defineConfig} from '../config'
import { utilsService } from './utils';
const {handleResponse} = utilsService;

export const schedulerService = {
  getApiPath,
  sendEventToScheduler
};

const {apiUrl, apiVer} = defineConfig.SCHEDULER_SERVICE

function getApiPath(){
  return (apiUrl+apiVer)
}

function sendEventToScheduler(payload) {
  const url = apiUrl+apiVer+"/eventScheduler/save";
  payload.callback.authUrl = apiUrl;
  const requestOptions = {
    method: "POST",
    headers: authHeader("application/json"),
    body: JSON.stringify(payload),
  };

  return fetch(url, requestOptions)
    .then(handleResponse)
    .then((res) => res);
}